import { useQuery, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { ShipmentTrackerURLSchema } from "@/schemas/ship";

export const useTrackerImageUrl = (filename: string) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ["ship", "image", filename],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `/ship/intshiptracking/trackerstage/image?filename=${filename}`,
        { baseURL: "/api/proxy" }
      );
      return ShipmentTrackerURLSchema.parse(response.data);
    },

    initialData: () =>
      queryClient.getQueryData(["ship", "image", filename]),

    enabled: !!filename,
  });
};
